// Which tasks get a quick action (call, text, or email buttons) on the task list.
// These patterns match the quick action components, so the admin list can show a gold label
// on every task that will have one. Keep them in step with the components when a new quick action is added.
const RULES = [
  { test: /schedule home inspection/i, label: 'Call / text inspector' },
  { test: /request professional staging/i, label: 'Email / text stager' },
  { test: /^create feature cards$/i, label: 'Send feature cards link for review' },
  { test: /^review and approve feature cards$/i, label: 'Approve and choose pickup' },
  { test: /^print and produce feature cards$/i, label: 'Open link and print' },
  { test: /^(create )?(brochures|mailers|just sold postcards)$/i, label: 'Send link for approval' },
  { test: /^review and approve (brochures|mailers|just sold postcards)$/i, label: 'Approve' },
  { test: /^order (brochures|mailers|just sold postcards) for printing$/i, label: 'Open approved link to order' },
  { test: /^create feature and upgrade list$/i, label: 'Paste link and mark done' },
  { test: /^review and print feature and upgrade list$/i, label: 'Open link to print' },
  { test: /^create social graphics$/i, label: 'Paste link and mark done' },
  { test: /^edit and download social graphics$/i, label: 'Open link to edit and download' },
  { test: /home sale contingency/i, label: 'Call / text listing agent' },
  { test: /^Text Other Agent: .*Walk Through/i, label: 'Text other agent' },
  { test: /^Text Client: Listing Is Live/i, label: 'Text client' },
  { test: /^Listing Expires (in \d+ Days|Tomorrow): Text Client/i, label: 'Text client (manual)' },
  { test: /^Send Title Initiation Email$/i, label: 'Review and send title email' },
  { test: /Punch List Items to Builder/i, label: 'Text builder' },
  { test: /Clear To Close/i, label: 'Call / text lender' },
  { test: /^Financing (\/ Appraisal Deadline|Contingency)/i, label: 'Call / text lender' },
  { test: /^Financing Check-In/i, label: 'Call / text lender' },
  { test: /^Introduce Yourself to the Listing Agent/i, label: 'Text / email listing agent' },
  { test: /^Home to Sell Contingency Status Check/i, label: 'Text / email listing agent' },
  { test: /^Send Utilities and Services Questionnaire to Seller/i, label: 'Review and send questionnaire' },
  { test: /^Add Client Birthdays$/i, label: 'Enter client birthdays' },
  { test: /^MANUAL SEND - Text Asking for Google Review/i, label: 'Text client for Google review' },
  { test: /^Post Closing 2 Day Up Check In|^2 Week Post Closing Call|^1 Month Post Closing Follow Up|^3 Month Post Close Follow Up|^6 Month Follow Up|^Home Anniversary Year \d+/i, label: 'Text client follow-up' },
  { test: /HOA\/Condo (Application|Packet|Approval)/i, label: 'Call / text / email client' },
  { test: /Setup\/Removal of Utilities/i, label: 'Call / text / email client' },
  { test: /Keys and Closing Day Access/i, label: 'Call / text / email client' },
  { test: /Confirm Closing Date\/Time/i, label: 'Call / text / email client' },
  { test: /^Connect with Client|^Confirm Closing Date\/Time & Connect with Client/i, label: 'Call / text / email client' },
  { test: /Text Client: .*(EMD|Walk Through)/i, label: 'Call / text / email client' },
  { test: /^(First|Second) EMD Due/i, label: 'Call / text client' },
  { test: /^Earnest Money Due Today/i, label: 'Call / text client' },
  { test: /\bEMD\b|earnest money/i, label: 'Call / text client' },
];

// Returns the quick action label for a task name, or null when the task has no quick action.
export const quickActionLabel = (name, type) => {
  if (!name || type === 'Notification') return null;
  const rule = RULES.find((r) => r.test.test(name));
  return rule ? `Quick action: ${rule.label}` : null;
};
